import { useState } from "react"
import {
  Flex,
  Text,
  Heading,
  Image,
  Button,
  Collapse,
  SimpleGrid,
} from "@chakra-ui/react"
import Document from "./Document"

const documente = [
  {
    text: "CG Asigurare de protectie daune electrice",
    url:
      "https://www.cezinfo.ro/wp-content/uploads/2021/01/CG-Asigurare-de-protectie-daune-electrice.pdf",
  },
  {
    text: "Document de informare",
    url:
      "https://www.cezinfo.ro/wp-content/uploads/2021/01/Document-de-informare-privind-asigurarea-de-protectie-impotriva-daunelor-electrice.pdf",
  },
  {
    text: "Nota de informare GDPR WTW",
    url:
      "https://www.cezinfo.ro/wp-content/uploads/2021/01/Nota-de-informare-GDPR-WTW.pdf",
  },
  {
    text: "Procedura in caz de daune",
    url:
      "https://www.cezinfo.ro/wp-content/uploads/2021/01/Procedura-in-caz-de-daune-WTW.pdf",
  },
]

const DauneElectrice = () => {
  const [expandedContent, setExpandedContent] = useState(false)
  const [hideButtonText, setHideButtonText] = useState("Afiseaza informatii")

  const handleHiddenContent = () => {
    if (expandedContent === true) {
      setExpandedContent(false)
      setHideButtonText("Afiseaza informatii")
    } else {
      setExpandedContent(true)
      setHideButtonText("Mai putine informatii")
    }
  }
  return (
    <Flex flexDirection="column" width="100%">
      <Flex flexDirection="column" alignItems="flex-start" width="100%">
        {/** Riscuri */}
        <Flex
          flexDirection="column"
          width="100%"
          alignItems={["center", "center", "center", "flex-start"]}
        >
          <Heading as="h5" size="sm">
            Serviciu complementar furnizarii de energie electrica oferit prin
            asigurarea
            <span style={{ color: "#063B7F" }}>
              {" "}
              AWP P&C SA Branch Austria - Allianz Partners
            </span>
            .
          </Heading>
          <Heading as="h4" size="sm" marginBottom="8px" marginTop="16px">
            Beneficii
          </Heading>
          <Flex
            flexDirection="row"
            alignItems="center"
            marginTop="8px"
            marginBottom="8px"
          >
            <Image
              marginRight="16px"
              src="/cez-confort-asigurat/assets/benefit.png"
              width="24px"
              height="24px"
            />
            <Text fontSize="xs" textAlign="left">
              Suma totala asigurata: maxim <strong>2000 de Euro</strong>
              /beneficiar/an conform conditiilor de asigurare mentionate mai jos
              in descriere si documente;
            </Text>
          </Flex>
          <Flex
            flexDirection="row"
            alignItems="center"
            marginTop="8px"
            marginBottom="8px"
          >
            <Image
              marginRight="16px"
              src="/cez-confort-asigurat/assets/benefit.png"
              width="24px"
              height="24px"
            />
            <Text fontSize="xs" textAlign="left">
              Despagubire reprezentand valoarea de achizitie a bunului dar nu
              mai mult de 250 de Euro/echipament;
            </Text>
          </Flex>
          <Flex
            flexDirection="row"
            alignItems="center"
            marginTop="8px"
            marginBottom="8px"
          >
            <Image
              marginRight="16px"
              src="/cez-confort-asigurat/assets/benefit.png"
              width="24px"
              height="24px"
            />
            <Text fontSize="xs" textAlign="left">
              Numarul maxim de echipamente electrice este de 8
              echipamente/beneficiar/an;
            </Text>
          </Flex>
          <Flex
            flexDirection="row"
            alignItems="center"
            marginTop="8px"
            marginBottom="8px"
          >
            <Image
              marginRight="16px"
              src="/cez-confort-asigurat/assets/benefit.png"
              width="24px"
              height="24px"
            />
            <Text fontSize="xs" textAlign="left">
              Numarul maxim de evenimente acoperite este de 2
              evenimente/beneficiar/an;
            </Text>
          </Flex>
        </Flex>
        {/** Sfarsit riscuri */}
        <Flex flexDirection="column" width="100">
          <Heading
            as="h4"
            size="sm"
            marginTop="8px"
            textAlign={["center", "center", "center", "left"]}
          >
            Criterii eligibilitate
          </Heading>
          <Collapse in={expandedContent} width="100%">
            <Text
              marginTop="16px"
              fontSize="sm"
              textAlign={["center", "center", "center", "left"]}
            >
              Persoana fizica, titular al unui contract activ pentru furnizarea
              energiei electrice cu tarif <strong>CEZ Confort Asigurat</strong>{" "}
              sau <strong>CEZ Confort Asigurat Plus</strong>
            </Text>
            <Flex width="100%" flexDirection="column">
              <Heading
                as="h5"
                size="sm"
                marginTop="16px"
                marginBottom="16px"
                textAlign={["center", "center", "center", "left"]}
              >
                Riscuri asigurate
              </Heading>
              <Text
                fontSize="sm"
                textAlign={["center", "center", "center", "left"]}
              >
                Sunt asigurate pagubele produse ca urmare a unui eveniment
                extern determinat de urmatoarele riscuri:
              </Text>
              <Text
                fontSize="sm"
                textAlign={["center", "center", "center", "left"]}
                marginTop="8px"
              >
                - scurtcircuit, supratensiune, supraintensitate (supracurent),
                suprasarcina, formare de arcuri voltaice sau inductie,
                intreruperi in reteaua electrica ca urmare a fluctuatiilor de
                tensiune
              </Text>
              <Text
                fontSize="sm"
                textAlign={["center", "center", "center", "left"]}
                marginTop="8px"
              >
                - actiunea indirecta a electricitatii atmosferice (trasnet)
                asupra bunurilor asigurate
              </Text>
              <Heading
                as="h5"
                size="sm"
                marginTop="16px"
                marginBottom="16px"
                textAlign={["center", "center", "center", "left"]}
              >
                Categorii de bunuri asigurate
              </Heading>
              <Text
                fontSize="sm"
                textAlign={["center", "center", "center", "left"]}
              >
                - Echipamente electrocasnice albe precum masina de spalat
                vase/rufe, frigider, combina frigorifica, aragaz, cuptor si/sau
                cuptor multifunctional (cuptor si microunde), plita, hota,
                espressor, gratar electric, dulap de vin, aspirator, televizoare
                si desktop-uri;
              </Text>
              <Text
                marginTop="8px"
                fontSize="sm"
                textAlign={["center", "center", "center", "left"]}
              >
                - Achizitionate de pe teritoriul Romaniei, a caror vechime este
                de maximum 6 ani, al caror pret initial de achizitie este de
                minimum 100 de Euro si care sunt functionale la data incheierii
                contractului de furnizare a energiei electrice;
              </Text>
              <Text
                marginTop="8px"
                fontSize="sm"
                textAlign={["center", "center", "center", "left"]}
              >
                - Bunurile trebuie sa fie in proprietatea beneficiarului, la
                adresa mentionata in contractul de furnizare energie (locul de
                consum);
              </Text>
            </Flex>
            <Heading
              as="h4"
              size="sm"
              marginTop="16px"
              textAlign={["center", "center", "center", "left"]}
            >
              Documente
            </Heading>
            <SimpleGrid minChildWidth="100px" spacing="16px" marginTop="16px">
              {documente.map((document) => (
                <Document
                  key={document.text + document.url}
                  documentText={document.text}
                  documentUrl={document.url}
                />
              ))}
            </SimpleGrid>
          </Collapse>
        </Flex>
      </Flex>
      <Flex
        justifyContent="center"
        alignItems="center"
        marginBottom={["-24px", "-24px", "-24px", "-48px"]}
        marginTop="16px"
      >
        <Button onClick={() => handleHiddenContent()}>{hideButtonText}</Button>
      </Flex>
    </Flex>
  )
}

export default DauneElectrice
